module.exports = __webpack_public_path__ + "img/empty_car.d6a187ac.png";